var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _path30, _g2, _path31, _g3, _path32, _g4, _path33, _g5, _path34, _g6, _path35, _g7, _path36, _g8, _path37, _g9, _path38, _g0, _path39, _g1, _path40, _g10, _path41, _g11, _path42, _g12, _path43, _g13, _path44, _g14, _path45, _g15, _path46, _g16, _path47, _g17, _path48, _g18, _path49, _g19, _path50, _g20, _path51, _g21, _path52, _g22, _path53, _g23, _path54, _g24, _path55, _g25, _path56, _g26, _path57, _g27, _path58, _g28, _path59, _g29, _path60, _g30, _path61, _g31, _path62, _g32, _path63, _g33, _path64, _g34, _path65, _g35, _path66, _g36, _path67, _g37, _path68, _g38, _path69, _g39, _path70, _g40, _path71, _g41, _path72, _g42, _path73, _g43, _path74, _g44, _path75, _g45, _path76, _g46, _path77, _g47, _path78, _g48, _path79, _g49, _path80, _g50, _path81, _g51, _path82, _g52, _path83, _g53, _path84, _g54, _path85, _g55, _path86, _g56, _path87, _g57, _path88, _g58, _path89, _g59, _path90, _g60, _path91, _g61, _path92, _g62, _path93, _g63, _path94, _g64, _path95, _g65, _path96, _g66, _path97, _g67, _path98, _g68, _path99, _g69, _path100, _g70, _path101, _g71, _path102, _g72, _path103, _g73, _path104, _g74, _path105, _g75, _path106, _g76, _path107, _g77, _path108, _g78, _path109, _g79, _path110, _g80, _path111, _g81, _path112, _g82, _path113, _g83, _path114, _g84, _path115, _g85, _path116, _g86, _path117, _g87, _path118, _g88, _path119, _g89, _path120, _g90, _path121, _g91, _path122, _g92, _path123, _g93, _path124, _g94, _path125, _g95, _path126, _g96, _path127, _g97, _path128, _g98, _path129, _g99, _path130, _g100, _path131, _g101, _path132, _g102, _path133, _g103, _path134, _g104, _path135, _g105, _path136, _g106, _path137, _g107, _path138, _g108, _path139, _g109, _path140, _g110, _path141, _g111, _path142, _g112, _path143, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9994 24.3415L23.3108 24.38L23.2538 24.4287L23.196 24.4212L22.4556 24.3189L19.5007 23.9144L6.9723 22.1965L0.658447 21.3311L1.20316 21.0551L11.2213 15.9805L26.5127 17.1219L23.2537 19.923C22.2241 20.8936 22.1506 23.4694 22.8561 24.2213C22.9002 24.2692 22.9489 24.3096 22.9994 24.3415Z",
    fill: "#4F7BDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.219 24.252C22.0205 23.5256 22.4736 21.0644 23.2539 20.2044L26.814 17.1443L27.2163 16.7988L30.7939 17.0663C30.9216 17.0756 30.9997 17.1836 30.9997 17.2944C30.9997 17.3808 30.9608 17.4677 30.8948 17.5221C30.8948 17.5221 23.7888 23.976 23.219 24.252Z",
    fill: "url(#paint0_linear_910_14705)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5415 11.8189L0.658451 16.825C-0.351888 17.4822 -0.0763337 21.0492 0.658451 21.3308L23.2537 24.4285C22.1515 24.3346 22.0597 21.0492 23.2537 19.9228L30.8552 13.3901C31.0308 13.2392 30.9381 12.9466 30.7092 12.9294L11.9781 11.531C11.4827 11.494 10.9866 11.5934 10.5415 11.8189Z",
    fill: "url(#paint1_linear_910_14705)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.3982 22.7416L0.0797119 20.0205C0.18585 20.6926 0.391645 21.2289 0.658449 21.3312L23.2537 24.4288C22.7367 24.3849 22.442 23.6382 22.3982 22.7416Z",
    fill: "url(#paint2_linear_910_14705)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.15476 16.5732L0.65842 16.8246C0.353617 17.0229 0.166538 17.4866 0.0731201 18.0442L22.7331 20.7099C22.8663 20.3984 23.0388 20.1251 23.2538 19.9223L24.0523 19.236L1.15476 16.5732Z",
    fill: "url(#paint3_linear_910_14705)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9996 17.6369C31.0029 17.7213 30.9784 17.7962 30.9206 17.8397L23.3915 24.3102L23.2537 24.4284C22.1418 24.3226 22.0679 21.0406 23.2537 19.9227L26.5127 17.1216L26.915 16.7762L30.7057 13.5189L30.8554 13.3903C30.8766 13.3724 30.8931 13.3527 30.9069 13.3311C30.9262 13.3011 30.9372 13.2682 30.9427 13.2354V13.5189C30.9335 13.5743 30.9059 13.6287 30.8554 13.6719L27.2163 16.7988L26.814 17.1442L23.2538 20.2043C22.4831 21.0634 22.4272 23.5838 23.1546 24.1056C23.3456 24.1469 30.7251 17.6395 30.7195 17.637C30.9297 17.4567 30.9996 17.4198 30.9996 17.2943V17.6369Z",
    fill: "url(#paint4_linear_910_14705)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.9996 17.6369C31.0029 17.7213 30.9784 17.7962 30.9206 17.8397L23.3915 24.3102L23.2537 24.4284C22.1418 24.3226 22.0679 21.0406 23.2537 19.9227L26.5127 17.1216L26.915 16.7762L30.7057 13.5189L30.8554 13.3903C30.8766 13.3724 30.8931 13.3527 30.9069 13.3311C30.9262 13.3011 30.9372 13.2682 30.9427 13.2354V13.5189C30.9335 13.5743 30.9059 13.6287 30.8554 13.6719L27.2163 16.7988L26.814 17.1442L23.2538 20.2043C22.4831 21.0634 22.4272 23.5838 23.1546 24.1056C23.3456 24.1469 30.7251 17.6395 30.7195 17.637C30.9297 17.4567 30.9996 17.4198 30.9996 17.2943V17.6369Z",
    fill: "url(#paint5_linear_910_14705)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.9997 17.2943V17.6368C31.0028 17.7213 30.9784 17.7962 30.9205 17.8397L23.3916 24.3103L23.2538 24.4284C23.0159 24.4058 22.8433 24.2449 22.7185 24.0355C22.5728 23.7927 22.4747 23.4553 22.4266 23.0733C22.3961 22.8293 22.3855 22.567 22.3963 22.2994C22.4327 21.3964 22.7099 20.4354 23.2538 19.9228L26.5128 17.1215L26.9151 16.7763L30.6688 13.5506L30.7057 13.5189L30.8555 13.3902C30.8766 13.3725 30.8932 13.3528 30.9069 13.331C30.9262 13.301 30.9372 13.2682 30.9428 13.2354V13.5189C30.9336 13.5743 30.9059 13.6287 30.8555 13.6721L30.6236 13.8714L27.2163 16.7988L26.8139 17.1442L23.2539 20.2043C22.5712 20.9651 22.4491 23.0296 22.9358 23.8539C22.9986 23.96 23.0715 24.0457 23.1546 24.1054C23.3457 24.1469 30.7253 17.6395 30.7193 17.6368C30.9302 17.4561 30.9997 17.4194 30.9997 17.2943Z",
    fill: "url(#paint6_linear_910_14705)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.9997 17.2944V17.6369C31.0028 17.7213 30.9784 17.7963 30.9205 17.8398L23.3916 24.3104L23.2538 24.4285C23.0163 24.4059 22.8435 24.2454 22.7185 24.0356C22.5728 23.7928 22.4747 23.4553 22.4266 23.0734C22.3961 22.8294 22.3855 22.567 22.3963 22.2995C22.3992 22.2257 22.4039 22.1516 22.4103 22.0773C22.4796 21.2425 22.7544 20.3935 23.2538 19.9228L26.5128 17.1215L26.9151 16.7763L30.6688 13.5506L30.7057 13.5189L30.8555 13.3902C30.8766 13.3725 30.8932 13.3528 30.9069 13.331C30.9262 13.301 30.9372 13.2682 30.9428 13.2354V13.5189C30.9336 13.5743 30.9059 13.6287 30.8555 13.6721L30.6236 13.8714L27.2163 16.7988L26.8139 17.1442L23.2539 20.2043C23.2475 20.2113 23.2414 20.2183 23.2351 20.2258C23.2287 20.2331 23.2226 20.2405 23.2165 20.2481C23.2104 20.2556 23.2043 20.2631 23.1981 20.2708C22.5648 21.0792 22.4627 23.0526 22.9359 23.8539C22.992 23.9491 23.0651 24.0408 23.1547 24.1054C23.3457 24.1469 30.7253 17.6395 30.7194 17.6368C30.9302 17.4562 30.9997 17.4194 30.9997 17.2944Z",
    fill: "url(#paint7_linear_910_14705)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7341 17.3363L23.0312 23.989C22.9969 23.9488 22.9651 23.9034 22.9358 23.8536C22.4626 23.0522 22.5647 21.0788 23.198 20.2705C23.2042 20.2627 23.2102 20.2553 23.2164 20.2478C23.2225 20.2403 23.2286 20.2328 23.235 20.2255C23.2413 20.218 23.2473 20.211 23.2537 20.204L26.8138 17.1439L27.2162 16.7985L30.6235 13.8711C30.4608 15.1176 30.4637 16.2881 30.7341 17.3363Z",
    fill: "url(#paint8_linear_910_14705)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93205 15.4734L19.0099 10.9932L29.2243 14.4176L9.73848 20.9321L1.88514 15.8724C1.72958 15.7722 1.75931 15.5187 1.93205 15.4734Z",
    fill: "#22DD3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72629 15.3657C1.74306 15.4636 1.74322 15.5334 2.0336 15.7115L9.25392 20.3719C9.28447 20.3839 9.74005 20.6203 9.77376 20.6091C10.5725 19.8287 9.88216 17.6145 9.05177 16.9123L5.40475 14.5621L4.99267 14.2969L1.87116 15.1162C1.75983 15.1452 1.7083 15.2603 1.72629 15.3657Z",
    fill: "url(#paint9_linear_910_14705)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96815 15.364L9.86419 20.479C9.88793 20.4353 9.90867 20.3871 9.9265 20.3351C10.2149 19.4978 9.80367 17.6359 9.11199 16.9666C9.10534 16.9603 9.0987 16.9541 9.09206 16.9478C9.08541 16.9417 9.07885 16.9356 9.07204 16.9296C9.06516 16.9235 9.05868 16.9178 9.05187 16.9122L5.08165 14.2142L1.86121 12.0488C2.2079 13.2095 2.03694 14.3238 1.96815 15.364Z",
    fill: "url(#paint10_linear_910_14705)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78192 15.6911C1.79278 15.7719 1.82657 15.8393 1.88482 15.8716L9.59743 20.8407L9.73856 20.9315C9.81829 20.9087 9.88902 20.8685 9.94946 20.8083C9.98892 20.77 10.0255 20.7238 10.0567 20.6714C10.5585 19.8445 10.0747 17.4049 9.00605 16.6437L1.7312 11.7258L1.57783 11.627C1.55628 11.6133 1.53845 11.5973 1.52274 11.5788C1.50078 11.5533 1.48482 11.5226 1.47461 11.4922L1.5216 11.7631C1.5387 11.8144 1.572 11.8618 1.62369 11.8949L9.05191 16.9115C9.87339 17.6073 10.3326 19.9969 9.77389 20.6083C9.6116 20.6778 2.02539 15.6501 2.02993 15.6467L1.84277 15.5264L1.82389 15.5142C1.76831 15.4781 1.73647 15.4239 1.72634 15.3649L1.78192 15.6911Z",
    fill: "url(#paint11_linear_910_14705)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.78192 15.6911C1.79278 15.7719 1.82657 15.8393 1.88482 15.8716L9.59743 20.8407L9.73856 20.9315C9.81829 20.9087 9.88902 20.8685 9.94946 20.8083C9.98892 20.77 10.0255 20.7238 10.0567 20.6714C10.5585 19.8445 10.0747 17.4049 9.00605 16.6437L1.7312 11.7258L1.57783 11.627C1.55628 11.6133 1.53845 11.5973 1.52274 11.5788C1.50078 11.5533 1.48482 11.5226 1.47461 11.4922L1.5216 11.7631C1.5387 11.8144 1.572 11.8618 1.62369 11.8949L9.05191 16.9115C9.87339 17.6073 10.3326 19.9969 9.77389 20.6083C9.6116 20.6778 2.02539 15.6501 2.02993 15.6467L1.84277 15.5264L1.82389 15.5142C1.76831 15.4781 1.73647 15.4239 1.72634 15.3649L1.78192 15.6911Z",
    fill: "url(#paint12_linear_910_14705)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.72622 15.365L1.78197 15.6909C1.7929 15.7718 1.82669 15.8392 1.88494 15.8715L9.59747 20.8407L9.73869 20.9314C9.81833 20.9086 9.88898 20.8683 9.94967 20.8082C9.98896 20.7699 10.0257 20.7237 10.0569 20.6714C10.0923 20.6128 10.1228 20.5463 10.1484 20.473C10.2379 20.2189 10.2697 19.8822 10.2502 19.5112C10.2375 19.2741 10.2042 19.0229 10.1512 18.77C9.97211 17.9163 9.57073 17.0456 9.00625 16.6437L1.76916 11.7501L1.73133 11.7258L1.57787 11.627C1.5564 11.6134 1.5385 11.5973 1.52286 11.5787C1.5009 11.5532 1.4851 11.5227 1.47473 11.4922L1.52156 11.7631C1.53882 11.8145 1.57204 11.8619 1.62365 11.8951L1.86396 12.0572L9.05195 16.9115C9.7796 17.5278 10.2231 19.4731 9.92658 20.3344C9.88825 20.4454 9.83778 20.5384 9.77393 20.6083C9.61156 20.678 2.02519 15.6503 2.02997 15.6467L1.84273 15.5266L1.82393 15.5142C1.76827 15.478 1.73627 15.4239 1.72622 15.365Z",
    fill: "url(#paint13_linear_910_14705)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.72618 15.3658L1.78184 15.6912C1.79278 15.7721 1.82665 15.8401 1.8849 15.8723L9.59637 20.8409L9.73849 20.9322C9.94947 20.8719 10.0746 20.6857 10.1482 20.4739C10.2377 20.2198 10.2694 19.8812 10.2499 19.5101C10.2373 19.2731 10.2035 19.0216 10.1505 18.7686C10.1359 18.699 10.1198 18.6288 10.1021 18.5593C9.90498 17.7758 9.52264 17.0117 9.00435 16.6427L1.76726 11.7491L1.72942 11.7248L1.57597 11.626C1.5545 11.6124 1.53659 11.5963 1.52095 11.5778C1.499 11.5523 1.48498 11.5236 1.47461 11.4932L1.51974 11.7622C1.537 11.8135 1.5703 11.861 1.62183 11.8942L1.86384 12.0582L9.05013 16.9106C9.05693 16.9162 9.06341 16.922 9.0703 16.9281C9.07711 16.934 9.08367 16.9402 9.09039 16.9463C9.09696 16.9525 9.1036 16.9586 9.11032 16.9651C9.80201 17.6344 10.215 19.4981 9.92662 20.3355C9.90879 20.3874 9.88805 20.4357 9.86431 20.4793C9.83798 20.5287 9.80768 20.5723 9.77389 20.6094C9.61152 20.679 2.02353 15.6494 2.02823 15.6458L1.84099 15.5257L1.82219 15.5133C1.76645 15.4769 1.73623 15.4247 1.72618 15.3658Z",
    fill: "url(#paint14_linear_910_14705)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9348 6.92539L28.4919 10.1294C29.4926 10.5953 29.8286 14.0332 29.2244 14.4172L9.73854 20.9317C10.6984 20.6684 10.2455 17.5274 9.00603 16.6439L1.57408 11.6258C1.39413 11.5099 1.43254 11.2181 1.63217 11.1657L17.6171 6.87811C18.0494 6.76484 18.5045 6.78115 18.9348 6.92539Z",
    fill: "url(#paint15_linear_910_14705)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.2213 19.1914L29.5233 13.0791C29.5387 13.7354 29.4439 14.2782 29.2244 14.4177L9.73853 20.9322C10.1889 20.8086 10.3282 20.0516 10.2213 19.1914Z",
    fill: "url(#paint16_linear_910_14705)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.012 9.96875L28.4919 10.1296C28.7938 10.2702 29.0346 10.6818 29.208 11.1979L9.59489 17.3114C9.42644 17.036 9.22924 16.8031 9.0061 16.6441L8.18811 16.1171L28.012 9.96875Z",
    fill: "url(#paint17_linear_910_14705)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0327 16.7831L18.9313 16.7176C18.1898 15.5934 18.1408 13.5755 18.8109 12.1424C18.9694 11.8034 19.2289 11.5244 19.5494 11.3402L23.4916 9.09087L23.7675 8.93652L29.7924 10.4705C29.853 10.4861 29.8853 10.5402 29.8838 10.5939C29.8829 10.6349 29.8802 10.7329 29.8389 10.7561L19.0327 16.7831Z",
    fill: "url(#paint18_linear_910_14705)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6862 6.18164C28.3484 7.93399 28.3723 9.5681 28.6862 11.1072L18.8729 16.6244C18.1726 15.4593 18.1638 13.4524 18.8284 12.06C18.9794 11.7432 19.2224 11.482 19.5248 11.3126L23.4916 9.09091L23.7676 8.93656L28.6862 6.18164Z",
    fill: "url(#paint19_linear_910_14705)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1312 13.1061C20.1312 13.1061 22.4778 11.8321 22.9911 11.5573C23.5044 11.2825 24.2865 10.8828 24.2865 10.8828C24.2865 10.8828 22.5266 11.9319 22.0377 12.1818C21.5489 12.4316 20.1312 13.1061 20.1312 13.1061Z",
    fill: "url(#paint20_linear_910_14705)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9253 0.59375L1.67691 6.02486C0.87026 7.01037 0.821404 10.6075 1.67691 11.5769L19.0231 16.9707C17.8337 15.9033 17.9314 13.0056 19.0231 11.4186L29.8214 5.37096C29.9176 5.31706 29.8991 5.17025 29.7926 5.14317L11.9253 0.59375Z",
    fill: "#A7EA86"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8839 5.26172V5.43843L29.3462 5.50648L29.5701 5.26172H29.8839Z",
    fill: "#A7EA86"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.884 5.26367V5.44228C29.8828 5.48302 29.8627 5.52326 29.8214 5.54619L23.7677 8.93679L23.4917 9.09114L19.5249 11.3128C19.2226 11.4821 18.9797 11.7435 18.8285 12.0601C18.1625 13.4555 18.1728 15.4677 18.8772 16.6319C18.9105 16.687 18.9625 16.7274 19.0231 16.7462L29.5252 10.8644L29.5255 10.8642L29.8137 10.7031L29.8215 10.6986C29.8628 10.6754 29.8832 10.6351 29.8841 10.5941V10.8158C29.8841 10.8177 29.8841 10.8197 29.8838 10.8217C29.8821 10.8616 29.862 10.9009 29.8214 10.9234L19.0905 16.9335L19.0231 16.9711C18.9216 16.8802 18.8297 16.7761 18.7468 16.6605C17.8576 15.4194 18.0243 12.8709 19.0231 11.419L23.2771 9.03674L23.553 8.88215L29.6378 5.47432H29.6381L29.8214 5.3714C29.832 5.36544 29.841 5.35865 29.8488 5.35061C29.8727 5.32693 29.884 5.29514 29.884 5.26367Z",
    fill: "url(#paint21_linear_910_14705)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M29.884 5.26367V5.44228C29.8828 5.48302 29.8627 5.52326 29.8214 5.54619L23.7677 8.93679L23.4917 9.09114L19.5249 11.3128C19.2226 11.4821 18.9797 11.7435 18.8285 12.0601C18.1625 13.4555 18.1728 15.4677 18.8772 16.6319C18.9105 16.687 18.9625 16.7274 19.0231 16.7462L29.5252 10.8644L29.5255 10.8642L29.8137 10.7031L29.8215 10.6986C29.8628 10.6754 29.8832 10.6351 29.8841 10.5941V10.8158C29.8841 10.8177 29.8841 10.8197 29.8838 10.8217C29.8821 10.8616 29.862 10.9009 29.8214 10.9234L19.0905 16.9335L19.0231 16.9711C18.9216 16.8802 18.8297 16.7761 18.7468 16.6605C17.8576 15.4194 18.0243 12.8709 19.0231 11.419L23.2771 9.03674L23.553 8.88215L29.6378 5.47432H29.6381L29.8214 5.3714C29.832 5.36544 29.841 5.35865 29.8488 5.35061C29.8727 5.32693 29.884 5.29514 29.884 5.26367Z",
    fill: "url(#paint22_linear_910_14705)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8839 5.2615C29.8839 5.29785 29.871 5.32815 29.8486 5.35018C29.8408 5.35821 29.8318 5.36492 29.8212 5.37096L29.6379 5.47389H29.6376L23.5528 8.88171L23.2769 9.0363L19.0228 11.4186C18.0241 12.8705 17.8573 15.419 18.7466 16.66C18.8294 16.7756 18.9214 16.8798 19.0228 16.9707L1.67677 11.5768C1.26859 11.1143 1.0662 10.0532 1.05372 8.96311V8.95483C1.04148 7.7633 1.25611 6.53873 1.67677 6.02494L11.9252 0.59375L29.7925 5.14317C29.8511 5.15808 29.8831 5.20933 29.8839 5.2615Z",
    fill: "url(#paint23_linear_910_14705)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2.806 5.42676L1.67689 6.02517C1.41511 6.34496 1.23313 6.93998 1.13599 7.63105L18.4523 12.6162C18.5929 12.1762 18.7841 11.7661 19.023 11.4188L20.2174 10.7501L2.806 5.42676Z",
    fill: "url(#paint24_linear_910_14705)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.67678 11.5771L19.0229 16.971C18.9215 16.8801 18.8295 16.776 18.7467 16.6603C18.4204 16.2048 18.2364 15.5732 18.1835 14.8845L1.10315 9.80469C1.18668 10.5688 1.37571 11.2359 1.67678 11.5771Z",
    fill: "url(#paint25_linear_910_14705)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8316 11.6123H21.3074V14.221H23.8316V11.6123Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8553 12.8882C23.8553 13.5929 23.2965 14.164 22.6071 14.164C21.9176 14.164 21.3588 13.5929 21.3588 12.8882C21.3588 12.1836 21.9176 11.6123 22.6071 11.6123C23.2964 11.6123 23.8553 12.1836 23.8553 12.8882Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5287 11.6596C22.0126 11.6729 21.5722 11.9668 21.3618 12.3851C21.3899 12.3912 21.415 12.4079 21.4282 12.4374C21.5117 12.6251 21.6093 12.8053 21.7082 12.985C21.7657 12.9478 21.8521 12.9592 21.8673 13.0463C21.8854 13.1513 21.8999 13.259 21.9149 13.3673C21.9474 13.4299 21.9793 13.4929 22.0095 13.5568C22.1026 13.7543 22.1876 13.9613 22.2353 14.1748C22.3492 14.202 22.4685 14.2153 22.5916 14.2121C23.3258 14.1932 23.9075 13.6065 23.8903 12.9017C23.8732 12.1967 23.2634 11.6407 22.5287 11.6596Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8457 12.8967C23.8499 12.1979 23.2989 11.628 22.6151 11.6238C21.9313 11.6195 21.3735 12.1825 21.3694 12.8813C21.3652 13.58 21.9162 14.1499 22.6 14.1542C23.2838 14.1585 23.8415 13.5955 23.8457 12.8967Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8347 12.8878C23.8347 13.5808 23.285 14.1426 22.607 14.1426C21.9289 14.1426 21.3792 13.5808 21.3792 12.8878C21.3792 12.1947 21.9289 11.6328 22.607 11.6328C23.285 11.6328 23.8347 12.1947 23.8347 12.8878Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5283 11.659C22.0122 11.6721 21.5717 11.9659 21.3613 12.3841C21.3893 12.3902 21.4144 12.4069 21.4276 12.4365C21.511 12.6241 21.6086 12.8044 21.7075 12.9841C21.765 12.947 21.8514 12.9584 21.8665 13.0455C21.8846 13.1505 21.8991 13.2582 21.9141 13.3665C21.9465 13.4291 21.9784 13.4922 22.0086 13.556C22.1017 13.7535 22.1866 13.9606 22.2342 14.1741C22.3481 14.2013 22.4674 14.2147 22.5905 14.2115C23.3247 14.1929 23.9066 13.6063 23.8896 12.9015C23.8727 12.1966 23.263 11.6403 22.5283 11.659Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8246 12.8958C23.8288 12.2086 23.2871 11.6479 22.6146 11.6435C21.9421 11.6391 21.3935 12.1926 21.3892 12.8798C21.3849 13.5669 21.9266 14.1276 22.5991 14.132C23.2717 14.1365 23.8203 13.583 23.8246 12.8958Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8142 12.8873C23.8142 13.5688 23.2737 14.1213 22.607 14.1213C21.9402 14.1213 21.3997 13.5688 21.3997 12.8873C21.3997 12.2059 21.9402 11.6533 22.607 11.6533C23.2737 11.6533 23.8142 12.2059 23.8142 12.8873Z",
    fill: "#FEFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5276 11.6589C22.0115 11.6721 21.571 11.9659 21.3606 12.3841C21.3887 12.3902 21.4138 12.4069 21.427 12.4365C21.5104 12.6241 21.608 12.8044 21.7069 12.9841C21.7644 12.9469 21.8508 12.9583 21.8659 13.0454C21.884 13.1505 21.8985 13.2581 21.9135 13.3664C21.9459 13.429 21.9779 13.4921 22.008 13.5559C22.1012 13.7534 22.1861 13.9605 22.2337 14.1741C22.3476 14.2012 22.4669 14.2146 22.5901 14.2114C23.3242 14.1927 23.9061 13.606 23.889 12.9012C23.872 12.1963 23.2623 11.6401 22.5276 11.6589Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8033 12.895C23.8074 12.2193 23.2747 11.6681 22.6135 11.6638C21.9524 11.6594 21.4131 12.2036 21.409 12.8792C21.4049 13.5548 21.9376 14.1061 22.5988 14.1104C23.26 14.1148 23.7993 13.5706 23.8033 12.895Z",
    fill: "#FEFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7938 12.8868C23.7938 13.5568 23.2624 14.0999 22.607 14.0999C21.9515 14.0999 21.4202 13.5568 21.4202 12.8868C21.4202 12.2168 21.9516 11.6738 22.607 11.6738C23.2624 11.6738 23.7938 12.2168 23.7938 12.8868Z",
    fill: "#FEFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7835 12.8871C23.7835 13.5513 23.2567 14.0897 22.6069 14.0897C21.9572 14.0897 21.4304 13.5513 21.4304 12.8871C21.4304 12.223 21.9572 11.6846 22.6069 11.6846C23.2567 11.6846 23.7835 12.223 23.7835 12.8871Z",
    fill: "#FEFDFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5288 11.66C22.0127 11.6731 21.5722 11.9669 21.3617 12.3851C21.3898 12.3912 21.4149 12.4079 21.4281 12.4375C21.5115 12.6251 21.6091 12.8054 21.708 12.9851C21.7655 12.9479 21.8519 12.9593 21.867 13.0465C21.8851 13.1515 21.8996 13.2591 21.9146 13.3674C21.947 13.4301 21.9789 13.4931 22.0091 13.557C22.1022 13.7545 22.1871 13.9615 22.2347 14.1751C22.3486 14.2023 22.4679 14.2156 22.591 14.2125C23.3252 14.1938 23.9071 13.6072 23.8901 12.9025C23.8732 12.1975 23.2635 11.6413 22.5288 11.66Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7737 12.896C23.7777 12.2377 23.2588 11.7006 22.6145 11.6963C21.9703 11.692 21.4448 12.2222 21.4408 12.8804C21.4367 13.5387 21.9557 14.0758 22.5999 14.0801C23.2442 14.0844 23.7697 13.5542 23.7737 12.896Z",
    fill: "#FDFDFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.763 12.8867C23.763 13.5392 23.2454 14.0683 22.6069 14.0683C21.9684 14.0683 21.4509 13.5392 21.4509 12.8867C21.4509 12.2341 21.9685 11.7051 22.6069 11.7051C23.2454 11.7051 23.763 12.2341 23.763 12.8867Z",
    fill: "#FDFDFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5295 11.6599C22.0134 11.673 21.573 11.9669 21.3625 12.3851C21.3906 12.3912 21.4157 12.4079 21.4289 12.4374C21.5124 12.6251 21.6099 12.8054 21.7088 12.985C21.7664 12.9479 21.8527 12.9593 21.8678 13.0464C21.886 13.1514 21.9005 13.2591 21.9155 13.3674C21.9479 13.43 21.9798 13.4931 22.01 13.5569C22.1031 13.7544 22.1881 13.9614 22.2357 14.175C22.3495 14.2022 22.4689 14.2155 22.592 14.2123C23.3261 14.1936 23.908 13.607 23.8909 12.9022C23.8739 12.1973 23.2643 11.6411 22.5295 11.6599Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7541 12.8958C23.758 12.2491 23.2481 11.7215 22.6152 11.7173C21.9823 11.7131 21.466 12.234 21.4621 12.8808C21.4582 13.5275 21.9681 14.0551 22.601 14.0593C23.2339 14.0635 23.7502 13.5426 23.7541 12.8958Z",
    fill: "#FDFCFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7424 12.8882C23.7424 13.5292 23.2341 14.0488 22.6069 14.0488C21.9798 14.0488 21.4713 13.5292 21.4713 12.8882C21.4713 12.2472 21.9797 11.7275 22.6069 11.7275C23.2341 11.7275 23.7424 12.2472 23.7424 12.8882Z",
    fill: "#FCFCFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5271 11.6585C22.011 11.6719 21.5706 11.9658 21.3603 12.3841C21.3884 12.3902 21.4135 12.4069 21.4267 12.4364C21.5102 12.6241 21.6078 12.8043 21.7068 12.9839C21.7643 12.9468 21.8507 12.9582 21.8658 13.0453C21.884 13.1503 21.8985 13.2579 21.9135 13.3662C21.946 13.4289 21.9779 13.4919 22.0081 13.5557C22.1013 13.7532 22.1863 13.9602 22.234 14.1738C22.3478 14.2009 22.4672 14.2142 22.5903 14.211C23.3244 14.1921 23.9061 13.6052 23.8888 12.9004C23.8716 12.1955 23.2618 11.6395 22.5271 11.6585Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7315 12.8933C23.7352 12.2582 23.2342 11.7401 22.6127 11.7362C21.9911 11.7323 21.4843 12.2441 21.4806 12.8792C21.477 13.5144 21.9779 14.0325 22.5995 14.0363C23.221 14.0402 23.7279 13.5285 23.7315 12.8933Z",
    fill: "#FCFBFB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7219 12.8887C23.7219 13.5182 23.2228 14.0284 22.6069 14.0284C21.9911 14.0284 21.4918 13.5182 21.4918 12.8887C21.4918 12.2593 21.9911 11.749 22.6069 11.749C23.2228 11.749 23.7219 12.2593 23.7219 12.8887Z",
    fill: "#FBFBFB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7117 12.8881C23.7117 13.5116 23.2171 14.0172 22.6069 14.0172C21.9967 14.0172 21.5021 13.5117 21.5021 12.8881C21.5021 12.2644 21.9966 11.7588 22.6069 11.7588C23.2171 11.7588 23.7117 12.2644 23.7117 12.8881Z",
    fill: "#FBFAFB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7014 12.8883C23.7014 13.5061 23.2114 14.007 22.6069 14.007C22.0024 14.007 21.5123 13.5061 21.5123 12.8883C21.5123 12.2704 22.0024 11.7695 22.6069 11.7695C23.2115 11.7695 23.7014 12.2704 23.7014 12.8883Z",
    fill: "#FBFAFA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6912 12.8886C23.6912 13.5007 23.2057 13.9968 22.6069 13.9968C22.008 13.9968 21.5226 13.5007 21.5226 12.8886C21.5226 12.2765 22.008 11.7803 22.6069 11.7803C23.2057 11.7803 23.6912 12.2764 23.6912 12.8886Z",
    fill: "#FAF9F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5287 11.6596C22.0126 11.6729 21.5722 11.9668 21.3618 12.3851C21.3899 12.3912 21.415 12.4079 21.4282 12.4374C21.5117 12.6251 21.6093 12.8053 21.7082 12.985C21.7657 12.9478 21.8521 12.9592 21.8673 13.0463C21.8854 13.1513 21.8999 13.259 21.9149 13.3673C21.9474 13.4299 21.9793 13.4929 22.0095 13.5568C22.1026 13.7543 22.1876 13.9613 22.2353 14.1748C22.3492 14.202 22.4685 14.2153 22.5916 14.2121C23.3258 14.1932 23.9075 13.6065 23.8903 12.9017C23.8732 12.1967 23.2634 11.6407 22.5287 11.6596Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6816 12.8945C23.6851 12.2883 23.2071 11.7938 22.6138 11.7901C22.0206 11.7863 21.5368 12.2746 21.5333 12.8809C21.5297 13.4871 22.0078 13.9816 22.601 13.9854C23.1943 13.9891 23.6781 13.5008 23.6816 12.8945Z",
    fill: "#FAF9F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6706 12.8881C23.6706 13.4886 23.1944 13.9754 22.6069 13.9754C22.0193 13.9754 21.5431 13.4886 21.5431 12.8881C21.5431 12.2877 22.0193 11.8008 22.6069 11.8008C23.1945 11.8008 23.6706 12.2877 23.6706 12.8881Z",
    fill: "#F9F8F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5288 11.66C22.0127 11.6731 21.5722 11.9669 21.3617 12.3851C21.3898 12.3912 21.4149 12.4079 21.4281 12.4375C21.5115 12.6251 21.6091 12.8054 21.708 12.9851C21.7655 12.9479 21.8519 12.9593 21.867 13.0465C21.8851 13.1515 21.8996 13.2591 21.9146 13.3674C21.947 13.4301 21.9789 13.4931 22.0091 13.557C22.1022 13.7545 22.1871 13.9615 22.2347 14.1751C22.3486 14.2023 22.4679 14.2156 22.591 14.2125C23.3252 14.1938 23.9071 13.6072 23.8901 12.9025C23.8732 12.1975 23.2635 11.6413 22.5288 11.66Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6609 12.8954C23.6646 12.3007 23.1958 11.8155 22.6139 11.8116C22.0319 11.8078 21.5572 12.2867 21.5536 12.8813C21.55 13.476 22.0187 13.9612 22.6007 13.965C23.1826 13.9689 23.6573 13.49 23.6609 12.8954Z",
    fill: "#F9F7F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6503 12.8887C23.6503 13.4776 23.1832 13.955 22.607 13.955C22.0309 13.955 21.5637 13.4776 21.5637 12.8887C21.5637 12.2998 22.0309 11.8223 22.607 11.8223C23.1832 11.8223 23.6503 12.2998 23.6503 12.8887Z",
    fill: "#F8F7F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.64 12.8879C23.64 13.471 23.1775 13.9437 22.607 13.9437C22.0364 13.9437 21.574 13.471 21.574 12.8879C21.574 12.3047 22.0364 11.832 22.607 11.832C23.1775 11.832 23.64 12.3047 23.64 12.8879Z",
    fill: "#F8F6F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6298 12.8882C23.6298 13.4655 23.1719 13.9335 22.607 13.9335C22.0422 13.9335 21.5842 13.4655 21.5842 12.8882C21.5842 12.3108 22.0422 11.8428 22.607 11.8428C23.1718 11.8428 23.6298 12.3108 23.6298 12.8882Z",
    fill: "#F7F5F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6195 12.8885C23.6195 13.46 23.1661 13.9233 22.607 13.9233C22.0478 13.9233 21.5945 13.46 21.5945 12.8885C21.5945 12.3169 22.0478 11.8535 22.607 11.8535C23.1661 11.8535 23.6195 12.3169 23.6195 12.8885Z",
    fill: "#F7F5F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6093 12.8887C23.6093 13.4545 23.1606 13.9131 22.6071 13.9131C22.0535 13.9131 21.6047 13.4545 21.6047 12.8887C21.6047 12.3229 22.0535 11.8643 22.6071 11.8643C23.1606 11.8643 23.6093 12.3229 23.6093 12.8887Z",
    fill: "#F6F4F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.599 12.888C23.599 13.448 23.1549 13.9019 22.607 13.9019C22.0591 13.9019 21.615 13.448 21.615 12.888C21.615 12.3279 22.0591 11.874 22.607 11.874C23.1548 11.874 23.599 12.3279 23.599 12.888Z",
    fill: "#F6F3F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5888 12.8882C23.5888 13.4424 23.1493 13.8917 22.6071 13.8917C22.0649 13.8917 21.6252 13.4424 21.6252 12.8882C21.6252 12.3341 22.0649 11.8848 22.6071 11.8848C23.1493 11.8848 23.5888 12.3341 23.5888 12.8882Z",
    fill: "#F5F3F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5786 12.8886C23.5786 13.437 23.1436 13.8815 22.607 13.8815C22.0704 13.8815 21.6355 13.437 21.6355 12.8886C21.6355 12.3402 22.0704 11.8955 22.607 11.8955C23.1436 11.8955 23.5786 12.3402 23.5786 12.8886Z",
    fill: "#F4F2F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5682 12.8888C23.5682 13.4314 23.1379 13.8712 22.6069 13.8712C22.076 13.8712 21.6456 13.4313 21.6456 12.8888C21.6456 12.3461 22.0761 11.9062 22.6069 11.9062C23.1378 11.9062 23.5682 12.3461 23.5682 12.8888Z",
    fill: "#F4F1F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.558 12.888C23.558 13.4248 23.1322 13.8601 22.607 13.8601C22.0818 13.8601 21.656 13.4248 21.656 12.888C21.656 12.3512 22.0818 11.916 22.607 11.916C23.1322 11.916 23.558 12.3512 23.558 12.888Z",
    fill: "#F3F0F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5477 12.8883C23.5477 13.4194 23.1266 13.8498 22.607 13.8498C22.0874 13.8498 21.6663 13.4194 21.6663 12.8883C21.6663 12.3572 22.0874 11.9268 22.607 11.9268C23.1266 11.9268 23.5477 12.3572 23.5477 12.8883Z",
    fill: "#F2F0F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5375 12.8886C23.5375 13.4139 23.1209 13.8396 22.607 13.8396C22.0931 13.8396 21.6765 13.4138 21.6765 12.8886C21.6765 12.3633 22.0932 11.9375 22.607 11.9375C23.1209 11.9375 23.5375 12.3633 23.5375 12.8886Z",
    fill: "#F2EFF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5273 12.8879C23.5273 13.4074 23.1152 13.8285 22.607 13.8285C22.0988 13.8285 21.6868 13.4073 21.6868 12.8879C21.6868 12.3684 22.0988 11.9473 22.607 11.9473C23.1152 11.9473 23.5273 12.3684 23.5273 12.8879Z",
    fill: "#F1EEEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.517 12.8881C23.517 13.4018 23.1096 13.8182 22.6069 13.8182C22.1044 13.8182 21.6969 13.4018 21.6969 12.8881C21.6969 12.3744 22.1044 11.958 22.6069 11.958C23.1096 11.958 23.517 12.3744 23.517 12.8881Z",
    fill: "#F1EDEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5068 12.8884C23.5068 13.3963 23.1038 13.8081 22.607 13.8081C22.11 13.8081 21.7073 13.3963 21.7073 12.8884C21.7073 12.3804 22.1101 11.9688 22.607 11.9688C23.1038 11.9687 23.5068 12.3804 23.5068 12.8884Z",
    fill: "#F0ECEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4965 12.8887C23.4965 13.3909 23.0983 13.7978 22.6069 13.7978C22.1157 13.7978 21.7174 13.3908 21.7174 12.8887C21.7174 12.3865 22.1157 11.9795 22.6069 11.9795C23.0983 11.9795 23.4965 12.3865 23.4965 12.8887Z",
    fill: "#EFECED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5346 11.6613C22.0184 11.6715 21.5763 11.9627 21.3636 12.3797C21.3916 12.3859 21.4167 12.4027 21.4297 12.4324C21.5121 12.6205 21.6087 12.8013 21.7066 12.9814C21.7644 12.9446 21.8507 12.9565 21.8653 13.0437C21.8829 13.1488 21.8968 13.2565 21.9112 13.3649C21.9433 13.4277 21.9749 13.4909 22.0047 13.555C22.0967 13.7529 22.1805 13.9604 22.227 14.1742C22.3407 14.202 22.46 14.2161 22.5831 14.2136C23.3174 14.1991 23.9025 13.6159 23.8893 12.9111C23.8762 12.2062 23.2695 11.6467 22.5346 11.6613Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4858 12.8998C23.4915 12.4036 23.1023 11.9965 22.6166 11.9905C22.1309 11.9844 21.7326 12.3818 21.7269 12.8779C21.7213 13.3741 22.1104 13.7813 22.5961 13.7873C23.0819 13.7933 23.4802 13.396 23.4858 12.8998Z",
    fill: "#EFEBEC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.476 12.8882C23.476 13.3787 23.0869 13.7764 22.607 13.7764C22.127 13.7764 21.7379 13.3787 21.7379 12.8882C21.7379 12.3976 22.1271 12 22.607 12C23.0869 12 23.476 12.3976 23.476 12.8882Z",
    fill: "#EEEAEB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5354 11.6602C22.0192 11.67 21.5769 11.9609 21.3639 12.3777C21.3919 12.384 21.4169 12.4008 21.4299 12.4305C21.5122 12.6186 21.6087 12.7995 21.7065 12.9798C21.7642 12.943 21.8506 12.955 21.8651 13.0422C21.8826 13.1473 21.8965 13.255 21.9108 13.3634C21.9428 13.4262 21.9744 13.4894 22.0042 13.5535C22.0961 13.7515 22.1797 13.9591 22.226 14.1729C22.3397 14.2008 22.459 14.2149 22.5822 14.2125C23.3165 14.1986 23.902 13.6158 23.8892 12.911C23.8766 12.2061 23.2703 11.6461 22.5354 11.6602Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4652 12.899C23.4711 12.4144 23.0912 12.0165 22.6168 12.0103C22.1424 12.004 21.7531 12.3918 21.7473 12.8764C21.7414 13.3611 22.1213 13.759 22.5957 13.7652C23.0701 13.7714 23.4594 13.3836 23.4652 12.899Z",
    fill: "#EDE9EB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4555 12.8888C23.4555 13.3678 23.0756 13.7561 22.607 13.7561C22.1383 13.7561 21.7584 13.3678 21.7584 12.8888C21.7584 12.4098 22.1383 12.0215 22.607 12.0215C23.0757 12.0215 23.4555 12.4098 23.4555 12.8888Z",
    fill: "#ECE8EA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4451 12.8881C23.4451 13.3613 23.0698 13.7449 22.6069 13.7449C22.1438 13.7449 21.7686 13.3613 21.7686 12.8881C21.7686 12.4149 22.1438 12.0312 22.6069 12.0312C23.0698 12.0312 23.4451 12.4149 23.4451 12.8881Z",
    fill: "#ECE7E9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.435 12.8884C23.435 13.3558 23.0643 13.7347 22.607 13.7347C22.1497 13.7347 21.7789 13.3558 21.7789 12.8884C21.7789 12.421 22.1496 12.042 22.607 12.042C23.0643 12.042 23.435 12.421 23.435 12.8884Z",
    fill: "#EBE6E8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4246 12.8886C23.4246 13.3502 23.0585 13.7245 22.6069 13.7245C22.1553 13.7245 21.7891 13.3502 21.7891 12.8886C21.7891 12.427 22.1553 12.0527 22.6069 12.0527C23.0586 12.0527 23.4246 12.427 23.4246 12.8886Z",
    fill: "#EAE5E7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4144 12.888C23.4144 13.3438 23.0528 13.7133 22.6069 13.7133C22.1608 13.7133 21.7993 13.3438 21.7993 12.888C21.7993 12.432 22.1608 12.0625 22.6069 12.0625C23.0528 12.0625 23.4144 12.432 23.4144 12.888Z",
    fill: "#E9E5E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4042 12.8882C23.4042 13.3383 23.0473 13.7031 22.6069 13.7031C22.1666 13.7031 21.8096 13.3383 21.8096 12.8882C21.8096 12.4382 22.1666 12.0732 22.6069 12.0732C23.0473 12.0732 23.4042 12.4382 23.4042 12.8882Z",
    fill: "#E9E4E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5346 11.6613C22.0184 11.6715 21.5763 11.9627 21.3636 12.3797C21.3916 12.3859 21.4167 12.4027 21.4297 12.4324C21.5121 12.6205 21.6087 12.8013 21.7066 12.9814C21.7644 12.9446 21.8507 12.9565 21.8653 13.0437C21.8829 13.1488 21.8968 13.2565 21.9112 13.3649C21.9433 13.4277 21.9749 13.4909 22.0047 13.555C22.0967 13.7529 22.1805 13.9604 22.227 14.1742C22.3407 14.202 22.46 14.2161 22.5831 14.2136C23.3174 14.1991 23.9025 13.6159 23.8893 12.9111C23.8762 12.2062 23.2695 11.6467 22.5346 11.6613Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3934 12.899C23.3985 12.4549 23.0502 12.0905 22.6154 12.0851C22.1807 12.0797 21.8242 12.4353 21.8191 12.8795C21.814 13.3236 22.1624 13.688 22.5971 13.6934C23.0318 13.6988 23.3884 13.3431 23.3934 12.899Z",
    fill: "#E8E3E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3837 12.8887C23.3837 13.3272 23.0359 13.6826 22.6069 13.6826C22.1779 13.6826 21.8301 13.3272 21.8301 12.8887C21.8301 12.4502 22.1779 12.0947 22.6069 12.0947C23.0359 12.0947 23.3837 12.4502 23.3837 12.8887Z",
    fill: "#E7E2E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5346 11.6613C22.0184 11.6715 21.5763 11.9627 21.3636 12.3797C21.3916 12.3859 21.4167 12.4027 21.4297 12.4324C21.5121 12.6205 21.6087 12.8013 21.7066 12.9814C21.7644 12.9446 21.8507 12.9565 21.8653 13.0437C21.8829 13.1488 21.8968 13.2565 21.9112 13.3649C21.9433 13.4277 21.9749 13.4909 22.0047 13.555C22.0967 13.7529 22.1805 13.9604 22.227 14.1742C22.3407 14.202 22.46 14.2161 22.5831 14.2136C23.3174 14.1991 23.9025 13.6159 23.8893 12.9111C23.8762 12.2062 23.2695 11.6467 22.5346 11.6613Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3729 12.8989C23.3779 12.4664 23.0386 12.1115 22.6152 12.1062C22.1918 12.101 21.8445 12.4473 21.8396 12.8799C21.8347 13.3124 22.1739 13.6673 22.5974 13.6726C23.0208 13.6779 23.368 13.3315 23.3729 12.8989Z",
    fill: "#E6E1E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3632 12.8883C23.3632 13.3151 23.0246 13.6612 22.607 13.6612C22.1893 13.6612 21.8507 13.3151 21.8507 12.8883C21.8507 12.4613 22.1893 12.1152 22.607 12.1152C23.0246 12.1152 23.3632 12.4613 23.3632 12.8883Z",
    fill: "#E6E0E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5356 11.6604C22.0193 11.6701 21.577 11.961 21.3639 12.3777C21.3919 12.384 21.4169 12.4009 21.4299 12.4305C21.5122 12.6187 21.6086 12.7996 21.7064 12.9798C21.7641 12.9431 21.8505 12.9551 21.865 13.0423C21.8825 13.1474 21.8963 13.2551 21.9106 13.3635C21.9426 13.4263 21.9742 13.4896 22.0039 13.5536C22.0958 13.7517 22.1794 13.9592 22.2257 14.1731C22.3394 14.201 22.4587 14.2151 22.5818 14.2128C23.3161 14.199 23.9018 13.6163 23.8891 12.9115C23.8767 12.2066 23.2705 11.6465 22.5356 11.6604Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3524 12.8983C23.3576 12.4773 23.0277 12.1316 22.6156 12.1261C22.2035 12.1206 21.8652 12.4574 21.8601 12.8784C21.8549 13.2994 22.1848 13.6451 22.5969 13.6506C23.009 13.6561 23.3472 13.3193 23.3524 12.8983Z",
    fill: "#E5DFE1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3427 12.8888C23.3427 13.3042 23.0134 13.6408 22.607 13.6408C22.2006 13.6408 21.8712 13.3042 21.8712 12.8888C21.8712 12.4734 22.2006 12.1367 22.607 12.1367C23.0133 12.1367 23.3427 12.4734 23.3427 12.8888Z",
    fill: "#E4DEE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3325 12.8881C23.3325 13.2976 23.0077 13.6296 22.607 13.6296C22.2064 13.6296 21.8815 13.2976 21.8815 12.8881C21.8815 12.4785 22.2064 12.1465 22.607 12.1465C23.0077 12.1465 23.3325 12.4785 23.3325 12.8881Z",
    fill: "#E3DDDF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3222 12.8884C23.3222 13.2921 23.002 13.6194 22.607 13.6194C22.2119 13.6194 21.8917 13.2921 21.8917 12.8884C21.8917 12.4845 22.2119 12.1572 22.607 12.1572C23.002 12.1572 23.3222 12.4845 23.3222 12.8884Z",
    fill: "#E2DCDE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.312 12.8886C23.312 13.2866 22.9964 13.6091 22.607 13.6091C22.2176 13.6091 21.902 13.2865 21.902 12.8886C21.902 12.4906 22.2177 12.168 22.607 12.168C22.9963 12.168 23.312 12.4906 23.312 12.8886Z",
    fill: "#E1DBDD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5356 11.6604C22.0193 11.6701 21.577 11.961 21.3639 12.3777C21.3919 12.384 21.4169 12.4009 21.4299 12.4305C21.5122 12.6187 21.6086 12.7996 21.7064 12.9798C21.7641 12.9431 21.8505 12.9551 21.865 13.0423C21.8825 13.1474 21.8963 13.2551 21.9106 13.3635C21.9426 13.4263 21.9742 13.4896 22.0039 13.5536C22.0958 13.7517 22.1794 13.9592 22.2257 14.1731C22.3394 14.201 22.4587 14.2151 22.5818 14.2128C23.3161 14.199 23.9018 13.6163 23.8891 12.9115C23.8767 12.2066 23.2705 11.6465 22.5356 11.6604Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3011 12.8976C23.3059 12.5055 22.9986 12.1836 22.6149 12.1785C22.2311 12.1733 21.9161 12.487 21.9113 12.879C21.9065 13.2711 22.2137 13.593 22.5975 13.5982C22.9812 13.6033 23.2962 13.2896 23.3011 12.8976Z",
    fill: "#E1DADC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2915 12.8882C23.2915 13.2745 22.9851 13.5878 22.607 13.5878C22.229 13.5878 21.9225 13.2745 21.9225 12.8882C21.9225 12.5017 22.229 12.1885 22.607 12.1885C22.9851 12.1885 23.2915 12.5017 23.2915 12.8882Z",
    fill: "#E0D9DB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5346 11.6613C22.0184 11.6715 21.5763 11.9627 21.3636 12.3797C21.3916 12.3859 21.4167 12.4027 21.4297 12.4324C21.5121 12.6205 21.6087 12.8013 21.7066 12.9814C21.7644 12.9446 21.8507 12.9565 21.8653 13.0437C21.8829 13.1488 21.8968 13.2565 21.9112 13.3649C21.9433 13.4277 21.9749 13.4909 22.0047 13.555C22.0967 13.7529 22.1805 13.9604 22.227 14.1742C22.3407 14.202 22.46 14.2161 22.5831 14.2136C23.3174 14.1991 23.9025 13.6159 23.8893 12.9111C23.8762 12.2062 23.2695 11.6467 22.5346 11.6613Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2807 12.8981C23.285 12.5177 22.9866 12.2055 22.6141 12.2008C22.2417 12.1962 21.9363 12.5009 21.9319 12.8814C21.9276 13.2619 22.226 13.5741 22.5984 13.5787C22.9709 13.5833 23.2763 13.2786 23.2807 12.8981Z",
    fill: "#DFD7DA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.271 12.8887C23.271 13.2635 22.9737 13.5673 22.607 13.5673C22.2403 13.5673 21.943 13.2635 21.943 12.8887C21.943 12.5138 22.2403 12.21 22.607 12.21C22.9737 12.21 23.271 12.5138 23.271 12.8887Z",
    fill: "#DED6D9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2607 12.8879C23.2607 13.257 22.968 13.5562 22.607 13.5562C22.2459 13.5562 21.9532 13.257 21.9532 12.8879C21.9532 12.5189 22.2459 12.2197 22.607 12.2197C22.968 12.2197 23.2607 12.5189 23.2607 12.8879Z",
    fill: "#DDD5D8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2504 12.8882C23.2504 13.2514 22.9623 13.5459 22.6069 13.5459C22.2515 13.5459 21.9634 13.2513 21.9634 12.8882C21.9634 12.5248 22.2516 12.2305 22.6069 12.2305C22.9623 12.2305 23.2504 12.5248 23.2504 12.8882Z",
    fill: "#DCD4D7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2402 12.8885C23.2402 13.2459 22.9567 13.5357 22.6069 13.5357C22.2571 13.5357 21.9736 13.246 21.9736 12.8885C21.9736 12.531 22.2571 12.2412 22.6069 12.2412C22.9567 12.2412 23.2402 12.531 23.2402 12.8885Z",
    fill: "#DBD3D6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5346 11.6613C22.0184 11.6715 21.5763 11.9627 21.3636 12.3797C21.3916 12.3859 21.4167 12.4027 21.4297 12.4324C21.5121 12.6205 21.6087 12.8013 21.7066 12.9814C21.7644 12.9446 21.8507 12.9565 21.8653 13.0437C21.8829 13.1488 21.8968 13.2565 21.9112 13.3649C21.9433 13.4277 21.9749 13.4909 22.0047 13.555C22.0967 13.7529 22.1805 13.9604 22.227 14.1742C22.3407 14.202 22.46 14.2161 22.5831 14.2136C23.3174 14.1991 23.9025 13.6159 23.8893 12.9111C23.8762 12.2062 23.2695 11.6467 22.5346 11.6613Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2295 12.8975C23.2335 12.546 22.9578 12.2575 22.6137 12.2532C22.2695 12.249 21.9873 12.5305 21.9833 12.882C21.9793 13.2336 22.255 13.522 22.5991 13.5263C22.9433 13.5306 23.2255 13.2491 23.2295 12.8975Z",
    fill: "#DAD2D5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2197 12.888C23.2197 13.234 22.9453 13.5144 22.6069 13.5144C22.2685 13.5144 21.9941 13.234 21.9941 12.888C21.9941 12.5421 22.2686 12.2617 22.6069 12.2617C22.9453 12.2617 23.2197 12.5421 23.2197 12.888Z",
    fill: "#D9D1D4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.607 13.5041C22.9397 13.5041 23.2095 13.2284 23.2095 12.8883C23.2095 12.5482 22.9397 12.2725 22.607 12.2725C22.2742 12.2725 22.0044 12.5482 22.0044 12.8883C22.0044 13.2284 22.2742 13.5041 22.607 13.5041Z",
    fill: "#D9D0D3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1992 12.8886C23.1992 13.2228 22.9341 13.4939 22.6069 13.4939C22.2798 13.4939 22.0146 13.2229 22.0146 12.8886C22.0146 12.5542 22.2798 12.2832 22.6069 12.2832C22.9341 12.2831 23.1992 12.5542 23.1992 12.8886Z",
    fill: "#D8CFD2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.189 12.8888C23.189 13.2174 22.9284 13.4837 22.607 13.4837C22.2855 13.4837 22.0249 13.2174 22.0249 12.8888C22.0249 12.5602 22.2855 12.2939 22.607 12.2939C22.9284 12.2939 23.189 12.5602 23.189 12.8888Z",
    fill: "#D7CDD1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1787 12.8881C23.1787 13.2109 22.9227 13.4726 22.6069 13.4726C22.2911 13.4726 22.035 13.2109 22.035 12.8881C22.035 12.5654 22.2911 12.3037 22.6069 12.3037C22.9227 12.3037 23.1787 12.5654 23.1787 12.8881Z",
    fill: "#D6CCD0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1685 12.8884C23.1685 13.2054 22.917 13.4624 22.607 13.4624C22.2968 13.4624 22.0454 13.2055 22.0454 12.8884C22.0454 12.5715 22.2967 12.3145 22.607 12.3145C22.9171 12.3145 23.1685 12.5715 23.1685 12.8884Z",
    fill: "#D5CBCF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1582 12.8887C23.1582 13.1998 22.9114 13.4521 22.6069 13.4521C22.3024 13.4521 22.0555 13.1998 22.0555 12.8887C22.0555 12.5774 22.3024 12.3252 22.6069 12.3252C22.9114 12.3252 23.1582 12.5774 23.1582 12.8887Z",
    fill: "#D4CACE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.148 12.888C23.148 13.1935 22.9058 13.441 22.607 13.441C22.3082 13.441 22.0659 13.1935 22.0659 12.888C22.0659 12.5826 22.3081 12.335 22.607 12.335C22.9058 12.335 23.148 12.5826 23.148 12.888Z",
    fill: "#D3C9CD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1377 12.8882C23.1377 13.1878 22.9001 13.4307 22.6069 13.4307C22.3138 13.4307 22.0762 13.1878 22.0762 12.8882C22.0762 12.5886 22.3138 12.3457 22.6069 12.3457C22.9002 12.3457 23.1377 12.5886 23.1377 12.8882Z",
    fill: "#D2C8CB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1273 12.8885C23.1273 13.1824 22.8943 13.4205 22.6069 13.4205C22.3193 13.4205 22.0863 13.1824 22.0863 12.8885C22.0863 12.5947 22.3193 12.3564 22.6069 12.3564C22.8943 12.3564 23.1273 12.5947 23.1273 12.8885Z",
    fill: "#D1C6CA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1172 12.8888C23.1172 13.1768 22.8888 13.4103 22.607 13.4103C22.3252 13.4103 22.0967 13.1768 22.0967 12.8888C22.0967 12.6008 22.3251 12.3672 22.607 12.3672C22.8888 12.3672 23.1172 12.6008 23.1172 12.8888Z",
    fill: "#D0C5C9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1069 12.8881C23.1069 13.1703 22.883 13.3992 22.6069 13.3992C22.3308 13.3992 22.1068 13.1703 22.1068 12.8881C22.1068 12.6058 22.3308 12.377 22.6069 12.377C22.8831 12.377 23.1069 12.6058 23.1069 12.8881Z",
    fill: "#CFC4C8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0967 12.8883C23.0967 13.1648 22.8775 13.3889 22.607 13.3889C22.3364 13.3889 22.1172 13.1648 22.1172 12.8883C22.1172 12.6118 22.3364 12.3877 22.607 12.3877C22.8775 12.3877 23.0967 12.6118 23.0967 12.8883Z",
    fill: "#CEC3C7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0865 12.8885C23.0865 13.1592 22.8719 13.3787 22.607 13.3787C22.3422 13.3787 22.1274 13.1592 22.1274 12.8885C22.1274 12.6178 22.3421 12.3984 22.607 12.3984C22.8718 12.3984 23.0865 12.6178 23.0865 12.8885Z",
    fill: "#CDC1C6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0763 12.8879C23.0763 13.1528 22.8661 13.3675 22.607 13.3675C22.3478 13.3675 22.1377 13.1528 22.1377 12.8879C22.1377 12.623 22.3478 12.4082 22.607 12.4082C22.8661 12.4082 23.0763 12.623 23.0763 12.8879Z",
    fill: "#CCC0C5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.066 12.8881C23.066 13.1472 22.8605 13.3573 22.607 13.3573C22.3535 13.3573 22.1479 13.1472 22.1479 12.8881C22.1479 12.6289 22.3535 12.4189 22.607 12.4189C22.8605 12.4189 23.066 12.6289 23.066 12.8881Z",
    fill: "#CBBFC3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0558 12.8884C23.0558 13.1418 22.8548 13.3471 22.607 13.3471C22.3591 13.3471 22.1582 13.1417 22.1582 12.8884C22.1582 12.6351 22.3591 12.4297 22.607 12.4297C22.8547 12.4297 23.0558 12.6351 23.0558 12.8884Z",
    fill: "#CABEC2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0454 12.8886C23.0454 13.1361 22.8491 13.3369 22.6069 13.3369C22.3648 13.3369 22.1685 13.1361 22.1685 12.8886C22.1685 12.6411 22.3648 12.4404 22.6069 12.4404C22.8491 12.4404 23.0454 12.6411 23.0454 12.8886Z",
    fill: "#C9BCC1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0352 12.888C23.0352 13.1298 22.8435 13.3257 22.607 13.3257C22.3704 13.3257 22.1787 13.1298 22.1787 12.888C22.1787 12.6462 22.3704 12.4502 22.607 12.4502C22.8435 12.4502 23.0352 12.6462 23.0352 12.888Z",
    fill: "#C8BBC0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0249 12.8882C23.0249 13.1242 22.8378 13.3155 22.607 13.3155C22.376 13.3155 22.189 13.1241 22.189 12.8882C22.189 12.6522 22.3761 12.4609 22.607 12.4609C22.8378 12.4609 23.0249 12.6522 23.0249 12.8882Z",
    fill: "#C7BABF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0147 12.8884C23.0147 13.1185 22.8322 13.3052 22.607 13.3052C22.3818 13.3052 22.1992 13.1185 22.1992 12.8884C22.1992 12.6582 22.3818 12.4717 22.607 12.4717C22.8322 12.4717 23.0147 12.6582 23.0147 12.8884Z",
    fill: "#C6B9BE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0045 12.8887C23.0045 13.1131 22.8265 13.295 22.607 13.295C22.3874 13.295 22.2095 13.1131 22.2095 12.8887C22.2095 12.6643 22.3874 12.4824 22.607 12.4824C22.8265 12.4824 23.0045 12.6643 23.0045 12.8887Z",
    fill: "#C5B7BC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9942 12.888C22.9942 13.1066 22.8208 13.2838 22.607 13.2838C22.3931 13.2838 22.2197 13.1065 22.2197 12.888C22.2197 12.6693 22.3932 12.4922 22.607 12.4922C22.8208 12.4922 22.9942 12.6693 22.9942 12.888Z",
    fill: "#C4B6BB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.984 12.8883C22.984 13.1011 22.8151 13.2736 22.607 13.2736C22.3987 13.2736 22.23 13.1011 22.23 12.8883C22.23 12.6755 22.3987 12.5029 22.607 12.5029C22.8151 12.5029 22.984 12.6755 22.984 12.8883Z",
    fill: "#C2B5BA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9737 12.8885C22.9737 13.0955 22.8096 13.2634 22.607 13.2634C22.4045 13.2634 22.2402 13.0955 22.2402 12.8885C22.2402 12.6814 22.4045 12.5137 22.607 12.5137C22.8096 12.5137 22.9737 12.6814 22.9737 12.8885Z",
    fill: "#C1B3B9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9635 12.8888C22.9635 13.0901 22.8038 13.2532 22.607 13.2532C22.41 13.2532 22.2505 13.09 22.2505 12.8888C22.2505 12.6875 22.4101 12.5244 22.607 12.5244C22.8038 12.5244 22.9635 12.6875 22.9635 12.8888Z",
    fill: "#C0B2B7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9532 12.8881C22.9532 13.0835 22.7982 13.2421 22.6069 13.2421C22.4157 13.2421 22.2607 13.0836 22.2607 12.8881C22.2607 12.6926 22.4157 12.5342 22.6069 12.5342C22.7982 12.5342 22.9532 12.6926 22.9532 12.8881Z",
    fill: "#BFB1B6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9429 12.8884C22.9429 13.0781 22.7925 13.2319 22.6069 13.2319C22.4213 13.2319 22.2709 13.0782 22.2709 12.8884C22.2709 12.6987 22.4213 12.5449 22.6069 12.5449C22.7925 12.5449 22.9429 12.6987 22.9429 12.8884Z",
    fill: "#BEAFB5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9327 12.8886C22.9327 13.0725 22.7869 13.2216 22.607 13.2216C22.427 13.2216 22.2812 13.0725 22.2812 12.8886C22.2812 12.7047 22.4271 12.5557 22.607 12.5557C22.7869 12.5557 22.9327 12.7047 22.9327 12.8886Z",
    fill: "#BDAEB4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9224 12.8879C22.9224 13.066 22.7812 13.2105 22.6069 13.2105C22.4326 13.2105 22.2914 13.0661 22.2914 12.8879C22.2914 12.7098 22.4326 12.5654 22.6069 12.5654C22.7812 12.5654 22.9224 12.7098 22.9224 12.8879Z",
    fill: "#BCACB2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9122 12.8882C22.9122 13.0605 22.7756 13.2002 22.6069 13.2002C22.4383 13.2002 22.3016 13.0606 22.3016 12.8882C22.3016 12.7159 22.4383 12.5762 22.6069 12.5762C22.7756 12.5761 22.9122 12.7159 22.9122 12.8882Z",
    fill: "#BBABB1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.902 12.8885C22.902 13.055 22.7699 13.1901 22.607 13.1901C22.444 13.1901 22.3119 13.055 22.3119 12.8885C22.3119 12.7219 22.444 12.5869 22.607 12.5869C22.7699 12.5869 22.902 12.7219 22.902 12.8885Z",
    fill: "#BAAAB0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8917 12.8888C22.8917 13.0496 22.7642 13.1798 22.6069 13.1798C22.4497 13.1798 22.3221 13.0496 22.3221 12.8888C22.3221 12.7281 22.4496 12.5977 22.6069 12.5977C22.7642 12.5977 22.8917 12.7281 22.8917 12.8888Z",
    fill: "#B8A8AE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8815 12.888C22.8815 13.043 22.7586 13.1687 22.607 13.1687C22.4554 13.1687 22.3324 13.043 22.3324 12.888C22.3324 12.733 22.4553 12.6074 22.607 12.6074C22.7587 12.6074 22.8815 12.733 22.8815 12.888Z",
    fill: "#B7A7AD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8712 12.8883C22.8712 13.0376 22.7529 13.1585 22.6069 13.1585C22.4609 13.1585 22.3427 13.0376 22.3427 12.8883C22.3427 12.7391 22.4609 12.6182 22.6069 12.6182C22.7529 12.6182 22.8712 12.7391 22.8712 12.8883Z",
    fill: "#B6A6AC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8609 12.8886C22.8609 13.032 22.7472 13.1482 22.6069 13.1482C22.4666 13.1482 22.3528 13.032 22.3528 12.8886C22.3528 12.7452 22.4665 12.6289 22.6069 12.6289C22.7472 12.6289 22.8609 12.7452 22.8609 12.8886Z",
    fill: "#B5A4AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8507 12.8879C22.8507 13.0255 22.7415 13.1371 22.607 13.1371C22.4723 13.1371 22.3632 13.0255 22.3632 12.8879C22.3632 12.7503 22.4723 12.6387 22.607 12.6387C22.7416 12.6387 22.8507 12.7503 22.8507 12.8879Z",
    fill: "#B4A3A9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8404 12.8881C22.8404 13.02 22.7359 13.1268 22.6069 13.1268C22.4779 13.1268 22.3733 13.02 22.3733 12.8881C22.3733 12.7563 22.4779 12.6494 22.6069 12.6494C22.7359 12.6494 22.8404 12.7563 22.8404 12.8881Z",
    fill: "#B3A1A8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8303 12.8884C22.8303 13.0144 22.7303 13.1166 22.607 13.1166C22.4836 13.1166 22.3837 13.0144 22.3837 12.8884C22.3837 12.7623 22.4836 12.6602 22.607 12.6602C22.7303 12.6602 22.8303 12.7623 22.8303 12.8884Z",
    fill: "#B2A0A7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8199 12.8887C22.8199 13.0089 22.7246 13.1064 22.6069 13.1064C22.4893 13.1064 22.3939 13.0089 22.3939 12.8887C22.3939 12.7684 22.4893 12.6709 22.6069 12.6709C22.7247 12.6709 22.8199 12.7684 22.8199 12.8887Z",
    fill: "#B09EA5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8097 12.8851C22.8097 12.9979 22.7189 13.0894 22.607 13.0894C22.4949 13.0894 22.4042 12.9979 22.4042 12.8851C22.4042 12.7721 22.4949 12.6807 22.607 12.6807C22.7189 12.6807 22.8097 12.7721 22.8097 12.8851Z",
    fill: "#AF9DA4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7996 12.8855C22.7996 12.9927 22.7134 13.0795 22.6071 13.0795C22.5008 13.0795 22.4146 12.9926 22.4146 12.8855C22.4146 12.7784 22.5007 12.6914 22.6071 12.6914C22.7134 12.6914 22.7996 12.7783 22.7996 12.8855Z",
    fill: "#AE9BA3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7892 12.8844C22.7892 12.9851 22.7076 13.0667 22.607 13.0667C22.5064 13.0667 22.4247 12.9851 22.4247 12.8844C22.4247 12.7837 22.5064 12.7021 22.607 12.7021C22.7076 12.7021 22.7892 12.7837 22.7892 12.8844Z",
    fill: "#AD9AA1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.779 12.885C22.779 12.98 22.702 13.057 22.6069 13.057C22.5119 13.057 22.4349 12.98 22.4349 12.885C22.4349 12.7899 22.5119 12.7129 22.6069 12.7129C22.7019 12.7129 22.779 12.7899 22.779 12.885Z",
    fill: "#AC99A0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7687 12.8845C22.7687 12.9738 22.6963 13.0462 22.607 13.0462C22.5177 13.0462 22.4452 12.9737 22.4452 12.8845C22.4452 12.7952 22.5177 12.7227 22.607 12.7227C22.6963 12.7227 22.7687 12.7952 22.7687 12.8845Z",
    fill: "#AA979E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7585 12.8849C22.7585 12.9685 22.6906 13.0364 22.607 13.0364C22.5233 13.0364 22.4554 12.9685 22.4554 12.8849C22.4554 12.8012 22.5233 12.7334 22.607 12.7334C22.6906 12.7334 22.7585 12.8012 22.7585 12.8849Z",
    fill: "#A9969D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7482 12.8854C22.7482 12.9635 22.685 13.0267 22.607 13.0267C22.529 13.0267 22.4657 12.9635 22.4657 12.8854C22.4657 12.8074 22.529 12.7441 22.607 12.7441C22.6849 12.7441 22.7482 12.8074 22.7482 12.8854Z",
    fill: "#A8949C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.738 12.8859C22.738 12.9582 22.6792 13.0169 22.607 13.0169C22.5346 13.0169 22.476 12.9582 22.476 12.8859C22.476 12.8135 22.5346 12.7549 22.607 12.7549C22.6792 12.7549 22.738 12.8135 22.738 12.8859Z",
    fill: "#A7939A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7278 12.8855C22.7278 12.9521 22.6737 13.0062 22.607 13.0062C22.5404 13.0062 22.4863 12.9521 22.4863 12.8855C22.4863 12.8188 22.5404 12.7646 22.607 12.7646C22.6737 12.7646 22.7278 12.8188 22.7278 12.8855Z",
    fill: "#A59199"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7174 12.8859C22.7174 12.9469 22.668 12.9964 22.607 12.9964C22.5459 12.9964 22.4965 12.9469 22.4965 12.8859C22.4965 12.8248 22.5459 12.7754 22.607 12.7754C22.668 12.7754 22.7174 12.8248 22.7174 12.8859Z",
    fill: "#A49097"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_910_14705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 3,
    height: 4
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8084 12.8002C23.7923 12.2729 23.502 11.8247 23.0914 11.6123C23.0856 11.641 23.0694 11.6668 23.0406 11.6805C22.8575 11.7669 22.6816 11.8678 22.5065 11.9699C22.5432 12.0285 22.5326 12.1168 22.4474 12.1328C22.3448 12.152 22.2395 12.1675 22.1336 12.1835C22.0725 12.217 22.011 12.25 21.9487 12.2813C21.7561 12.3776 21.554 12.4657 21.3453 12.5158C21.3194 12.6323 21.3071 12.7543 21.311 12.8801C21.3339 13.6301 21.9117 14.221 22.6013 14.1991C23.291 14.1773 23.8314 13.5508 23.8084 12.8002Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_910_14705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7072 12.8864C22.7072 12.9419 22.6623 12.9867 22.6069 12.9867C22.5515 12.9867 22.5067 12.9418 22.5067 12.8864C22.5067 12.8311 22.5516 12.7861 22.6069 12.7861C22.6623 12.7861 22.7072 12.8311 22.7072 12.8864Z",
    fill: "#A38E96"
  })))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2067 12.5426L22.9984 11.5566C22.9984 11.5566 23.6875 11.7679 23.8483 12.5426C24.0091 13.3173 23.8483 14.0451 23.8483 14.0451L23.1821 13.3877L22.5134 14.6554C22.5134 14.6554 22.2959 13.2031 21.9924 12.9198C21.6891 12.6365 21.2067 12.5426 21.2067 12.5426Z",
    fill: "url(#paint26_linear_910_14705)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_910_14705",
    x1: 22.4834,
    y1: 20.5254,
    x2: 30.9997,
    y2: 20.5254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F7BDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4267B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_910_14705",
    x1: 7.27256,
    y1: 24.4674,
    x2: 22.4123,
    y2: 12.5723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F7BDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4267B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_910_14705",
    x1: 11.5689,
    y1: 23.0082,
    x2: 11.7606,
    y2: 21.5386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_910_14705",
    x1: 12.1642,
    y1: 17.707,
    x2: 11.9724,
    y2: 19.3957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5229,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_910_14705",
    x1: 18.3453,
    y1: 13.5999,
    x2: 28.8405,
    y2: 19.6435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742,
    stopColor: "#829EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F7BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_910_14705",
    x1: 18.3453,
    y1: 13.5999,
    x2: 28.8405,
    y2: 19.6435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742,
    stopColor: "#829EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F7BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_910_14705",
    x1: 18.3443,
    y1: 13.5999,
    x2: 28.8402,
    y2: 19.6438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742,
    stopColor: "#829EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F7BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_910_14705",
    x1: 18.3444,
    y1: 13.6,
    x2: 28.8402,
    y2: 19.6439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742,
    stopColor: "#829EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F7BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_910_14705",
    x1: 27.6209,
    y1: 19.8886,
    x2: 25.9666,
    y2: 17.9756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2523,
    stopColor: "#F7E7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3745,
    stopColor: "#F5E3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5527,
    stopColor: "#F0D7B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7652,
    stopColor: "#E8C396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDA86A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_910_14705",
    x1: 1.72277,
    y1: 17.4532,
    x2: 10.1276,
    y2: 17.4532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22DD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CB831"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_910_14705",
    x1: 5.23245,
    y1: 17.7016,
    x2: 6.95518,
    y2: 15.4404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2523,
    stopColor: "#F7E7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3745,
    stopColor: "#F5E3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5527,
    stopColor: "#F0D7B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7652,
    stopColor: "#E8C396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDA86A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_910_14705",
    x1: 12.4968,
    y1: 8.90838,
    x2: 2.76505,
    y2: 15.6041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742,
    stopColor: "#49DD5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22DD3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_910_14705",
    x1: 12.4968,
    y1: 8.90838,
    x2: 2.76505,
    y2: 15.6041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742,
    stopColor: "#49DD5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22DD3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_910_14705",
    x1: 12.4968,
    y1: 8.90833,
    x2: 2.76512,
    y2: 15.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742,
    stopColor: "#49DD5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22DD3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_910_14705",
    x1: 12.4968,
    y1: 8.90914,
    x2: 2.76514,
    y2: 15.6047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742,
    stopColor: "#49DD5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22DD3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_910_14705",
    x1: 20.504,
    y1: 16.3848,
    x2: 8.60303,
    y2: 9.35522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22DD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CB831"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_910_14705",
    x1: 19.8893,
    y1: 17.8507,
    x2: 19.5079,
    y2: 16.6564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_910_14705",
    x1: 18.4259,
    y1: 12.6184,
    x2: 19.0222,
    y2: 14.4342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5229,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_910_14705",
    x1: 18.3399,
    y1: 12.8598,
    x2: 29.884,
    y2: 12.8598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8913E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_910_14705",
    x1: 24.5929,
    y1: 13.2047,
    x2: 22.7821,
    y2: 9.41081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2523,
    stopColor: "#F7E7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3656,
    stopColor: "#F4E2C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    stopColor: "#EBD4B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7281,
    stopColor: "#DDBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9481,
    stopColor: "#C99D6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4955E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_910_14705",
    x1: 22.2431,
    y1: 12.0694,
    x2: 22.1534,
    y2: 11.8814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2523,
    stopColor: "#F7E7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3745,
    stopColor: "#F5E3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5527,
    stopColor: "#F0D7B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7652,
    stopColor: "#E8C396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDA86A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_910_14705",
    x1: 16.2129,
    y1: 10.5866,
    x2: 27.8496,
    y2: 11.3042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8913E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5115,
    stopColor: "#F78F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7571,
    stopColor: "#F28934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    stopColor: "#E97E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_910_14705",
    x1: 16.2129,
    y1: 10.5866,
    x2: 27.8496,
    y2: 11.3042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8913E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5115,
    stopColor: "#F78F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7571,
    stopColor: "#F28934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    stopColor: "#E97E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_910_14705",
    x1: 11.3312,
    y1: 10.4491,
    x2: 21.1806,
    y2: 0.37122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8913E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_910_14705",
    x1: 10.952,
    y1: 8.10858,
    x2: 10.2905,
    y2: 10.3491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5229,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_910_14705",
    x1: 9.88779,
    y1: 13.97,
    x2: 10.2947,
    y2: 12.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_910_14705",
    x1: 23.2136,
    y1: 14.0015,
    x2: 22.1317,
    y2: 11.7347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0134,
    stopColor: "#E90D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5462,
    stopColor: "#FF5952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5884,
    stopColor: "#FD534B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F84038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#EF2318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7691,
    stopColor: "#E90D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.9949830bc1194d0f477b973812319ce5.svg";
export { ForwardRef as ReactComponent };